import { MHTopic } from '@data/mh_topics';

export enum GetCareFlow {
	vc = 'vc',
	hrt_e = 'hrt_e',
	hrt_t = 'hrt_t',
	mh_medication = 'mh_medication',
	mh_therapy = 'mh_therapy',
	adhd = 'adhd',
}

export interface ITopicCard {
	id: number;
	isActive: boolean;
	topic: string;
	flow: 'vhc_sub' | 'hrt_e_sub' | 'hrt_t_sub' | 'mh_sub' | 'gaht_consult';
	ineligible?: boolean;
	mhId?: string;
}

export interface ITopic {
	id: number;
	isActive: boolean;
	topic: string;
	flow: GetCareFlow;
	path: 'vhc_sub' | 'hrt_e_sub' | 'hrt_t_sub' | 'mh_sub' | 'gaht_consult';
	ineligible?: boolean;
	mhId?: string;
	unavailableStates?: string[];
}

type topicCategory =
	| 'genderAffirmingCareTopics'
	| 'feelingIllTopics'
	| 'sexualAndReproductiveHealthTopics'
	| 'mentalHealthTopics'
	| 'fertilityAndFamilyBuilding';

export const dataConstants: Record<topicCategory, ITopic[]> = {
	genderAffirmingCareTopics: [
		{
			id: 0,
			topic: 'Estrogen',
			flow: GetCareFlow.hrt_e,
			path: 'hrt_e_sub',
			isActive: true,
		},
		{
			id: 1,
			topic: 'Testosterone',
			flow: GetCareFlow.hrt_t,
			path: 'hrt_t_sub',
			isActive: true,
		},
		{
			id: 2,
			topic: 'GAHT/HRT consult',
			flow: GetCareFlow.vc,
			path: 'gaht_consult',
			isActive: true,
		},
		{
			id: 34,
			topic: 'Gender marker letter',
			flow: GetCareFlow.vc,
			path: 'vhc_sub',
			isActive: true,
			unavailableStates: ['GA', 'KY', 'TN', 'FL', 'TX', 'AR', 'OK', 'KS', 'LA'],
		},
		{
			id: 35,
			topic: 'Mental Health Surgery Letter',
			flow: GetCareFlow.mh_therapy,
			path: 'mh_sub',
			mhId: MHTopic.MENTAL_HEALTH_LETTER,
			isActive: true,
		},
		{
			id: 3,
			topic: 'Pre or post surgery consult',
			flow: GetCareFlow.vc,
			path: 'vhc_sub',
			isActive: true,
		},
	],
	feelingIllTopics: [
		{
			id: 4,
			topic: 'Anxiety & Depression',
			flow: GetCareFlow.mh_medication,
			path: 'mh_sub',
			mhId: MHTopic.MEDICATION_MANAGEMENT,
			isActive: true,
		},
		{
			id: 33,
			topic: 'ADHD',
			flow: GetCareFlow.adhd,
			path: 'mh_sub',
			mhId: MHTopic.ADHD,
			isActive: true,
		},
		{
			id: 5,
			topic: 'Well exam',
			flow: GetCareFlow.vc,
			path: 'vhc_sub',
			isActive: true,
		},
		{
			id: 34,
			topic: 'Gender marker letter',
			flow: GetCareFlow.vc,
			path: 'vhc_sub',
			isActive: true,
			unavailableStates: ['GA', 'KY', 'TN', 'FL', 'TX', 'AR', 'OK', 'KS', 'LA'],
		},
		{
			id: 6,
			topic: 'Hypertension',
			flow: GetCareFlow.vc,
			path: 'vhc_sub',
			isActive: true,
		},
		{
			id: 7,
			topic: 'Diabetes',
			flow: GetCareFlow.vc,
			path: 'vhc_sub',
			isActive: true,
		},
		{
			id: 8,
			topic: 'UTI',
			flow: GetCareFlow.vc,
			path: 'vhc_sub',
			isActive: true,
		},
		{
			id: 9,
			topic: 'Thyroid disease',
			flow: GetCareFlow.vc,
			path: 'vhc_sub',
			isActive: true,
		},
		{
			id: 10,
			topic: 'Cough / respiratory infection',
			flow: GetCareFlow.vc,
			path: 'vhc_sub',
			isActive: true,
		},
		{
			id: 11,
			topic: 'Dermatology care',
			flow: GetCareFlow.vc,
			path: 'vhc_sub',
			isActive: true,
		},
		{
			id: 12,
			topic: 'Migraines',
			flow: GetCareFlow.vc,
			path: 'vhc_sub',
			isActive: true,
		},
		{
			id: 13,
			topic: 'Hair loss',
			flow: GetCareFlow.vc,
			path: 'vhc_sub',
			isActive: true,
		},
		{
			id: 14,
			topic: 'Stomach issues',
			flow: GetCareFlow.vc,
			path: 'vhc_sub',
			isActive: true,
		},
		{
			id: 15,
			topic: 'Asthma',
			flow: GetCareFlow.vc,
			path: 'vhc_sub',
			isActive: true,
		},
		{
			id: 16,
			topic: 'Weight management',
			flow: GetCareFlow.vc,
			path: 'vhc_sub',
			isActive: true,
		},
		{
			id: 17,
			topic: 'Smoking cessation',
			flow: GetCareFlow.vc,
			path: 'vhc_sub',
			isActive: true,
		},
		{
			id: 18,
			topic: 'Something else',
			flow: GetCareFlow.vc,
			path: 'vhc_sub',
			isActive: true,
		},
	],
	sexualAndReproductiveHealthTopics: [
		{
			id: 19,
			topic: 'STI testing & treatment',
			flow: GetCareFlow.vc,
			path: 'vhc_sub',
			isActive: true,
		},
		{
			id: 20,
			topic: 'Menopause',
			flow: GetCareFlow.vc,
			path: 'vhc_sub',
			isActive: true,
		},
		{
			id: 21,
			topic: 'Low testosterone',
			flow: GetCareFlow.vc,
			path: 'vhc_sub',
			isActive: true,
		},
		{
			id: 22,
			topic: 'PrEP',
			flow: GetCareFlow.vc,
			path: 'vhc_sub',
			isActive: true,
		},
		{
			id: 23,
			topic: 'Sexual function / satisfaction',
			flow: GetCareFlow.vc,
			path: 'vhc_sub',
			isActive: true,
		},
		{
			id: 24,
			topic: 'Genital symptoms',
			flow: GetCareFlow.vc,
			path: 'vhc_sub',
			isActive: true,
		},
		{
			id: 25,
			topic: 'Birth control',
			flow: GetCareFlow.vc,
			path: 'vhc_sub',
			isActive: true,
		},
		{
			id: 26,
			topic: 'Something else',
			flow: GetCareFlow.vc,
			path: 'vhc_sub',
			isActive: true,
		},
	],
	mentalHealthTopics: [
		{
			id: 27,
			topic: 'Anxiety & Depression',
			flow: GetCareFlow.mh_medication,
			path: 'mh_sub',
			mhId: MHTopic.MEDICATION_MANAGEMENT,
			isActive: true,
		},
		{
			id: 33,
			topic: 'ADHD',
			flow: GetCareFlow.adhd,
			path: 'mh_sub',
			mhId: MHTopic.ADHD,
			isActive: true,
		},
		{
			id: 28,
			topic: 'Talk therapy',
			flow: GetCareFlow.mh_therapy,
			path: 'mh_sub',
			mhId: MHTopic.TALK_THERAPY,
			isActive: true,
		},
		{
			id: 35,
			topic: 'Mental Health Surgery Letter',
			flow: GetCareFlow.mh_therapy,
			path: 'mh_sub',
			mhId: MHTopic.MENTAL_HEALTH_LETTER,
			isActive: true,
		},
	],
	fertilityAndFamilyBuilding: [
		{
			id: 29,
			topic: 'Parent consultation',
			flow: GetCareFlow.vc,
			path: 'vhc_sub',
			isActive: true,
		},
		{
			id: 30,
			topic: 'Preconception evaluation',
			flow: GetCareFlow.vc,
			path: 'vhc_sub',
			isActive: true,
		},
		{
			id: 31,
			topic: 'Family building consultation',
			flow: GetCareFlow.vc,
			path: 'vhc_sub',
			isActive: true,
		},
		{
			id: 32,
			topic: 'Fertility consultation',
			flow: GetCareFlow.vc,
			path: 'vhc_sub',
			isActive: true,
		},
	],
};

export const testContent = {
	heading: 'Get care',
	description: 'What can we help you with?',
	genderAffirmingCareLabel: 'Gender affirming care',
	sexualAndReproductiveHealthLabel: 'Sexual & reproductive health',
	wellnessAndPreventativeCareLabel: 'Wellness & preventative care',
	feelingIllLabel: 'Feeling ill',
	mentalHealthLabel: 'Mental health',
	fertilityAndFamilyBuildingLabel: 'Fertility & family building',
};
